export default __webpack_public_path__ + "static/media/Certified.75a567e6.svg";